/* ============================================================================
   INJEXO — Paiement via Whop.

   Chaque variante peut porter un lien de paiement Whop (métachamp
   whop.checkout_url), exposé par snippets/injexo-whop-links.liquid.

   Ce script est chargé AVANT assets/injexo-cart.js. Ses écouteurs, posés sur
   document en phase de capture, passent donc en premier. Quand la variante a
   un lien Whop, il envoie le client vers ce lien et arrête l'événement
   (stopImmediatePropagation) : le panier Shopify n'est pas utilisé. Sans lien,
   il ne fait rien et le panier fonctionne comme avant.

   Cas gérés :
     form.ixpd-form                      fiche produit  → lien de la variante
     a.ix-card-cart[data-variant-id]     carte produit  → lien de la variante
     a.ix-cart-checkout (vers /checkout) panier latéral → 1 article : son lien ;
                                         plusieurs : un bouton de paiement par article

   Fiche produit : le champ quantité étant masqué, le bouton passe en pleine
   largeur, et son libellé « Acheter maintenant » est rétabli après chaque
   changement de lot (le script de la fiche remet sinon « Ajouter au panier »).

   Suivi Google Ads : à l'arrivée sur le site, les paramètres de clic
   (gclid, gbraid, wbraid) et les UTM sont gardés 90 jours dans le navigateur,
   puis ajoutés au lien Whop. Google Analytics, branché sur Whop, rattache
   ainsi l'achat à la publicité qui a amené le client.

   Comptage de la vente (page Merci) : au clic sur un lien Whop, le site
   retient le produit et son prix (ix_pending). Whop renvoie le client sur
   /pages/merci après le paiement ; le script y envoie alors un événement
   « purchase » à Google Analytics (G-002LWJDEDF), avec l'identifiant de clic
   publicitaire, importé ensuite comme conversion dans Google Ads. Le choix du
   visiteur sur les cookies (API Shopify) est respecté via le mode Consentement :
   sans réponse, l'achat part tout de suite en mode « refusé » (sans cookies).
   Test sans produit réel : ajouter ?ix_test=1 à n'importe quelle page du site.

   Début de paiement : au clic sur un bouton menant à Whop, un événement
   « begin_checkout » (produit, prix) part vers Google Analytics avant de
   quitter le site (attente maximale 0,6 s). Il complète l'entonnoir
   vue produit → début de paiement → achat. Même règle de consentement.
   ========================================================================== */
(function () {
  "use strict";

  var LINKS = null;
  function links() {
    if (LINKS) return LINKS;
    try {
      var el = document.getElementById("ix-whop-links");
      LINKS = el ? JSON.parse(el.textContent) : {};
    } catch (e) { LINKS = {}; }
    return LINKS;
  }
  function linkFor(id) { return id ? links()[String(id)] || null : null; }

  var I18N = {
    fr: { pay: "Payer", buy: "Acheter maintenant", perItem: "Le paiement se fait article par article :" },
    en: { pay: "Pay", buy: "Buy now", perItem: "Payment is made item by item:" },
    es: { pay: "Pagar", buy: "Comprar ahora", perItem: "El pago se realiza artículo por artículo:" },
    de: { pay: "Bezahlen", buy: "Jetzt kaufen", perItem: "Die Zahlung erfolgt Artikel für Artikel:" },
    it: { pay: "Paga", buy: "Acquista ora", perItem: "Il pagamento avviene articolo per articolo:" }
  };
  var lang = (document.documentElement.getAttribute("lang") || "fr").toLowerCase().slice(0, 2);
  var T = I18N[lang] || I18N.fr;

  var ROOT = "/";
  try { if (window.Shopify && Shopify.routes && Shopify.routes.root) ROOT = Shopify.routes.root; } catch (e) {}
  if (ROOT.charAt(ROOT.length - 1) !== "/") ROOT += "/";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Paramètres de clic publicitaire et UTM, gardés 90 jours */
  var ATTR_KEYS = ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var ATTR_STORE = "ix_attr";
  var ATTR_DAYS = 90;
  (function saveAttr() {
    try {
      var q = new URLSearchParams(window.location.search), found = {}, any = false;
      ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) { found[k] = v; any = true; } });
      if (any) localStorage.setItem(ATTR_STORE, JSON.stringify({ t: Date.now(), p: found }));
    } catch (e) {}
  })();
  function withAttr(url) {
    try {
      var raw = localStorage.getItem(ATTR_STORE);
      if (!raw) return url;
      var a = JSON.parse(raw);
      if (!a || !a.p || Date.now() - a.t > ATTR_DAYS * 864e5) return url;
      var u = new URL(url, window.location.href);
      Object.keys(a.p).forEach(function (k) { if (!u.searchParams.has(k)) u.searchParams.set(k, a.p[k]); });
      var clk = a.p.gclid ? a.p.gclid : a.p.gbraid ? "gbraid_" + a.p.gbraid : a.p.wbraid ? "wbraid_" + a.p.wbraid : "";
      if (clk && !u.searchParams.has("utm_content")) u.searchParams.set("utm_content", clk);
      return u.toString();
    } catch (e) { return url; }
  }

  /* Produit en cours d'achat, retenu pour la page Merci */
  var PENDING = "ix_pending";
  var ITEMS = null;
  function items() {
    if (ITEMS) return ITEMS;
    try {
      var el = document.getElementById("ix-whop-items");
      ITEMS = el ? JSON.parse(el.textContent) : {};
    } catch (e) { ITEMS = {}; }
    return ITEMS;
  }
  function savePending(id, it) {
    try {
      it = it || items()[String(id)] || (String(id) === "TEST" ? { n: "Test Injexo", p: 1, c: "EUR" } : {});
      localStorage.setItem(PENDING, JSON.stringify({
        v: String(id), n: it.n || "", p: Number(it.p) || 0, c: it.c || "EUR",
        t: Date.now(), r: Math.random().toString(36).slice(2, 10)
      }));
    } catch (e) {}
  }

  /* Visiteur venu d'une annonce Google (gclid / gbraid / wbraid encore valable) :
     au lieu du lien Whop fixe, on demande un lien de paiement personnalisé qui
     garde l'identifiant du clic (programme Google Apps Script « Injexo - paiement
     Whop avec gclid »). Même offre, même prix, même page Merci. L'agent de
     commandes relit ensuite ce gclid et l'envoie à Google Ads avec la vente.
     En cas d'échec ou de lenteur (> 3,5 s), on garde le lien fixe : la vente
     n'est jamais bloquée. Les autres visiteurs gardent le lien fixe. */
  var GCLID_EP = "https://script.google.com/macros/s/AKfycbxh8A3cmNbc3dvbAJAc0oVzrSCYAGKX9jsWGVj02TAIAsjM6irtXpxvcje7ae3NrZiq/exec";
  function clickAttr() {
    try {
      var a = JSON.parse(localStorage.getItem(ATTR_STORE) || "null");
      if (!a || !a.p || Date.now() - a.t > ATTR_DAYS * 864e5) return null;
      return (a.p.gclid || a.p.gbraid || a.p.wbraid) ? a.p : null;
    } catch (e) { return null; }
  }
  function go(url, id) {
    if (id) savePending(id);
    beginCheckout(id, function () { goNow(url, id); });
  }
  function goNow(url, id) {
    var fallback = withAttr(url), p = clickAttr();
    if (!p || !id || typeof fetch !== "function") { window.location.href = fallback; return; }
    var done = false;
    function leave(u) { if (done) return; done = true; window.location.href = u; }
    var timer = setTimeout(function () { leave(fallback); }, 3500);
    try { document.documentElement.style.cursor = "progress"; } catch (e) {}
    var q = new URLSearchParams();
    q.set("v", String(id));
    Object.keys(p).forEach(function (k) { if (ATTR_KEYS.indexOf(k) >= 0) q.set(k, p[k]); });
    fetch(GCLID_EP + "?" + q.toString())
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearTimeout(timer);
        leave(d && d.ok && /^https:\/\/(www\.)?whop\.com\/checkout\//.test(d.url || "") ? d.url : fallback);
      })
      .catch(function () { clearTimeout(timer); leave(fallback); });
  }

  /* Fiche produit */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains("ixpd-form")) return;
    var input = form.querySelector('[name="id"]');
    var url = linkFor(input && input.value);
    if (!url) return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(url, input.value);
  }, true);

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Carte produit (collection, accueil) */
    var card = t.closest("a.ix-card-cart[data-variant-id]");
    if (card) {
      var url = linkFor(card.getAttribute("data-variant-id"));
      if (!url) return;
      e.preventDefault(); e.stopImmediatePropagation();
      go(url, card.getAttribute("data-variant-id"));
      return;
    }

    /* Panier à plusieurs articles : un bouton de paiement par article */
    var pay = t.closest(".ix-whop-list a[data-ix-v]");
    if (pay) { savePending(pay.getAttribute("data-ix-v")); beginCheckout(pay.getAttribute("data-ix-v")); return; }

    /* Bouton « Commander » du panier latéral */
    var co = t.closest("a.ix-cart-checkout");
    if (co && /\/checkout\/?$/.test(co.getAttribute("href") || "")) {
      e.preventDefault(); e.stopImmediatePropagation();
      fetch(ROOT + "cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart.items || []).filter(function (i) { return linkFor(i.variant_id); });
          if (!items.length || items.length !== cart.items.length) { go(co.getAttribute("href")); return; }
          if (items.length === 1) { go(linkFor(items[0].variant_id), items[0].variant_id); return; }
          var box = document.createElement("div");
          box.className = "ix-whop-list";
          box.innerHTML = "<p>" + esc(T.perItem) + "</p>" + items.map(function (i) {
            var name = i.product_title + (i.variant_title && i.variant_title !== "Default Title" ? " · " + i.variant_title : "");
            return '<a class="ix-cart-checkout" data-ix-v="' + esc(i.variant_id) + '" href="' + esc(withAttr(linkFor(i.variant_id))) + '">' + esc(T.pay) + " — " + esc(name) + "</a>";
          }).join("");
          co.replaceWith(box);
        })
        .catch(function () { go(co.getAttribute("href")); });
    }
  }, true);

  /* Bouton de la fiche produit : pleine largeur et libellé « Acheter maintenant » */
  function fixForm(form) {
    var sel = form.querySelector("[data-ixpd-variant-select]");
    var idIn = form.querySelector('[name="id"]');
    var ids = sel ? Array.prototype.map.call(sel.options, function (o) { return o.value; }) : [idIn && idIn.value];
    if (!ids.some(function (id) { return linkFor(id); })) return;
    var q = form.querySelector(".ixpd-qty");
    if (q && q.parentNode) q.parentNode.style.gridTemplateColumns = "1fr";
    var btn = form.querySelector("[data-ixpd-atc]");
    var txt = btn && btn.querySelector(".t4s-btn-atc_text");
    if (txt && !btn.disabled) txt.textContent = T.buy;
  }
  function fixAll() { document.querySelectorAll("form.ixpd-form").forEach(fixForm); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fixAll); else fixAll();
  document.addEventListener("change", function (e) {
    var f = e.target && e.target.closest && e.target.closest("form.ixpd-form");
    if (f) fixForm(f);
  });

  /* Test : ?ix_test=1 → produit « Test Injexo » à 1 € */
  var TEST_URL = "https://whop.com/checkout/ch_CGhbzBH4pnbgDXV/";
  try {
    if (new URLSearchParams(window.location.search).get("ix_test") === "1") {
      /* après le chargement de Google Analytics (1,5 s au plus), pour tester aussi begin_checkout */
      var testGo = function () {
        prepCheckoutTag();
        var n = 0;
        (function wait() { if (BC.loaded || n++ > 15) go(TEST_URL, "TEST"); else setTimeout(wait, 100); })();
      };
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", testGo); else setTimeout(testGo, 0);
    }
  } catch (e) {}

  /* Page Merci : envoi de l'achat à Google Analytics */
  var GA_ID = "G-002LWJDEDF";
  var PENDING_MAX_MS = 24 * 3600e3;

  /* Choix cookies du visiteur (bandeau Shopify).
     Pas d'attente : si le visiteur n'a pas encore répondu, l'achat part tout de
     suite en mode « refusé » (signal sans cookies du mode Consentement Google).
     S'il répond ensuite, onLater reçoit son choix (mise à jour du consentement). */
  function withConsent(cb, onLater) {
    var done = false, listening = false;
    function fin(a, m) { if (!done) { done = true; cb(a, m); } }
    function read() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return false;
        var cur = typeof cp.currentVisitorConsent === "function" ? cp.currentVisitorConsent() : null;
        var undecided = cur && cur.analytics === "" &&
          (typeof cp.shouldShowBanner !== "function" || cp.shouldShowBanner());
        if (undecided) {
          if (!listening) {
            listening = true;
            document.addEventListener("visitorConsentCollected", function () {
              try {
                if (onLater) onLater(cp.analyticsProcessingAllowed() !== false,
                  typeof cp.marketingAllowed === "function" ? cp.marketingAllowed() !== false : true);
              } catch (e) {}
            });
          }
          fin(false, false);
          return true;
        }
        fin(cp.analyticsProcessingAllowed() !== false,
            typeof cp.marketingAllowed === "function" ? cp.marketingAllowed() !== false : true);
        return true;
      } catch (e) { return false; }
    }
    if (read()) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
          if (err || !read()) fin(false, false);
        });
        setTimeout(function () { fin(false, false); }, 3000);
        return;
      }
    } catch (e) {}
    fin(false, false);
  }

  /* Chargement de gtag.js : identifiant Google Ads d'abord, puis Analytics en
     secours si le premier chargement échoue (les deux traitent toute la file). */
  function loadGtag(ids) {
    if (!ids.length) return;
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + ids[0];
    s.onerror = function () { loadGtag(ids.slice(1)); };
    document.head.appendChild(s);
  }

  function sendPurchase() {
    if (!/\/pages\/merci\/?$/.test(window.location.pathname)) return;
    var pend = null;
    try { pend = JSON.parse(localStorage.getItem(PENDING) || "null"); } catch (e) {}
    if (!pend || !pend.t || Date.now() - pend.t > PENDING_MAX_MS) return;
    try { localStorage.removeItem(PENDING); } catch (e) {}
    withConsent(function (analytics, marketing) {
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };
      gtag("consent", "default", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied"
      });
      gtag("js", new Date());
      gtag("config", GA_ID, {
        send_page_view: false,
        page_location: withAttr(window.location.origin + window.location.pathname)
      });
      var value = Number(pend.p) || 0;
      gtag("event", "purchase", {
        send_to: GA_ID,
        transaction_id: "ixw-" + pend.t + "-" + pend.r,
        value: value,
        currency: pend.c || "EUR",
        items: [{ item_id: pend.v, item_name: pend.n, price: value, quantity: 1 }]
      });
      try { var ADS_ID = "AW-17746201809"; var at = JSON.parse(localStorage.getItem(ATTR_STORE) || "null"); if (at && at.p && Date.now() - at.t <= ATTR_DAYS * 864e5) { var cu = new URL(window.location.href), ch = false; ["gclid", "gbraid", "wbraid"].forEach(function (k) { if (at.p[k] && !cu.searchParams.has(k)) { cu.searchParams.set(k, at.p[k]); ch = true; } }); if (ch) history.replaceState(history.state, "", cu.toString()); } gtag("config", ADS_ID, { send_page_view: false }); gtag("event", "conversion", { send_to: ADS_ID + "/Ra-gCPXoyZMdENGZho5C", value: value, currency: pend.c || "EUR", transaction_id: "ixw-" + pend.t + "-" + pend.r }); } catch (e) {}
      loadGtag(["AW-17746201809", GA_ID, GA_ID + "&l=dataLayer"]);
    }, function (analytics, marketing) {
      /* Réponse au bandeau après l'envoi : mise à jour du consentement, puis
         renvoi de l'achat avec le même numéro (Google ne le compte qu'une fois). */
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };
      gtag("consent", "update", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied"
      });
      var value = Number(pend.p) || 0, tid = "ixw-" + pend.t + "-" + pend.r;
      if (analytics) gtag("event", "purchase", { send_to: GA_ID, transaction_id: tid, value: value, currency: pend.c || "EUR",
        items: [{ item_id: pend.v, item_name: pend.n, price: value, quantity: 1 }] });
      if (marketing) gtag("event", "conversion", { send_to: "AW-17746201809/Ra-gCPXoyZMdENGZho5C", value: value, currency: pend.c || "EUR", transaction_id: tid });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sendPurchase); else sendPurchase();

  /* Début de paiement (begin_checkout) vers Google Analytics.
     gtag.js n'est chargé que sur les pages qui ont un lien Whop (hors page
     Merci), sans page vue (déjà comptée par l'application Google de Shopify,
     qui partage les mêmes cookies _ga). */
  var BC = { on: false, loaded: false };
  function bcGtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  function prepCheckoutTag() {
    if (BC.on || /\/pages\/merci\/?$/.test(window.location.pathname)) return;
    if (!Object.keys(links()).length) return;
    BC.on = true;
    withConsent(function (analytics, marketing) {
      bcGtag("consent", "default", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied"
      });
      bcGtag("js", new Date());
      bcGtag("config", GA_ID, { send_page_view: false });
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
      s.onload = function () { BC.loaded = true; };
      document.head.appendChild(s);
    }, function (analytics, marketing) {
      bcGtag("consent", "update", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied"
      });
    });
  }
  /* Envoie begin_checkout puis appelle next() (au plus tard après 0,6 s). */
  function beginCheckout(id, next) {
    var called = false;
    function fin() { if (!called) { called = true; if (next) next(); } }
    try {
      var it = id ? (items()[String(id)] || (String(id) === "TEST" ? { n: "Test Injexo", p: 1, c: "EUR" } : null)) : null;
      if (!it || !BC.on) { fin(); return; }
      var value = Number(it.p) || 0;
      var ev = {
        send_to: GA_ID, currency: it.c || "EUR", value: value, transport_type: "beacon",
        items: [{ item_id: String(id), item_name: it.n || "", price: value, quantity: 1 }]
      };
      if (BC.loaded && next) { ev.event_callback = fin; setTimeout(fin, 600); }
      bcGtag("event", "begin_checkout", ev);
      if (!(BC.loaded && next)) fin();
    } catch (e) { fin(); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", prepCheckoutTag); else prepCheckoutTag();
})();
